import styled from "styled-components";

const FormWrapper = styled.div`
    width: calc(100% - 32px);
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 16px;

    @media (min-width: 481px) {
        width: calc(100% - 48px);
    }

    @media (min-width: 641px) {
        width: 534px;
        flex-direction: row;
        align-items: center;
        margin-top: 0;
    }
`

export default FormWrapper